import dayjs from "dayjs";
import { ClubBookingApiClient } from "../../common/api/ClubBookingApiClient";
import { Call, RecordCallOutcomePayload } from "../../model/members/Calls";

function normalizeCall(raw: Record<string, unknown>): Call {
  return {
    taskId: Number(raw.taskId ?? 0),
    memberId: raw.memberId == null ? null : Number(raw.memberId),
    memberName: raw.memberName == null ? null : String(raw.memberName),
    membershipId: raw.membershipId == null ? null : String(raw.membershipId),
    // dueDate is a date-only field the DateReviver may revive into a Date; normalise.
    dueDate: dayjs(raw.dueDate as string).format("YYYY-MM-DD"),
  };
}

export class CallsService extends ClubBookingApiClient {
  /** The logged-in staff member's open calls due on or before `date` (today + overdue). */
  async getMyCalls(date: string): Promise<Call[]> {
    const raw = await this.get<Record<string, unknown>[]>("/dashboard/calls", { date }, { showLoading: false });
    return Array.isArray(raw) ? raw.map(normalizeCall) : [];
  }

  /**
   * Records an outcome — logs a follow-up attributed to me and completes the call.
   * The date of the call itself is derived server-side (the day it was actioned); the
   * caller supplies `nextFollowUpDate`, which the API requires (FORT-366).
   */
  async recordOutcome(taskId: number, payload: RecordCallOutcomePayload): Promise<void> {
    // The caller owns the messaging: the base client's generic "Success!" toast on top of a
    // specific "Call outcome recorded" is two notifications for one click, one of them
    // saying nothing. Errors are rethrown either way, so the caller still reports failure.
    await this.post(`/dashboard/calls/${taskId}/outcome`, payload, {
      showSuccess: false,
      showError: false,
    });
  }
}
